/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MentorInputs */

const en__field_mentor = /** @type {(inputs: _Field_MentorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentor`)
};

const de__field_mentor = /** @type {(inputs: _Field_MentorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentor`)
};

/**
* | output |
* | --- |
* | "Mentor" |
*
* @param {_Field_MentorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_mentor = /** @type {((inputs?: _Field_MentorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MentorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mentor(inputs)
	return de__field_mentor(inputs)
});